import { BatchCreate } from './batch-create';
import { BatchDelete } from './batch-delete';
import { BatchUpdate } from './batch-update';

export class BatchModification<T> {
    creates: BatchCreate<T>[];
    updates: BatchUpdate<T>[];
    deletes: BatchDelete<T>[];

    constructor() {
        this.creates = [];
        this.updates = [];
        this.deletes = [];
    }
}
